import cx from 'classnames'
import type React from 'react'

import { useAuth } from '@/hooks'
import { useProjectAccess } from '../../../../../../../../../hooks'
import css from './Settings.module.scss'

type Props = {
  onClickDelete?: () => void
  onClickEdit?: () => void
  owner: string
}

const Settings: React.FC<Props> = ({ onClickDelete, onClickEdit, owner }) => {
  const auth = useAuth()

  const { hasAccess } = useProjectAccess('DELETE_OTHER_COMMENT')

  return (
    <div className={css.container}>
      {auth.id === owner && (
        <>
          <div className={css.item} onClick={onClickEdit}>
            Edit
          </div>

          <div className={css.divider} />
        </>
      )}

      {(auth.id === owner || hasAccess) && (
        <div className={cx(css.item, css.danger)} onClick={onClickDelete}>
          Delete
        </div>
      )}
    </div>
  )
}

export default Settings
